import React from "react";
import { useParams } from "react-router-dom";
import { Box, Flex } from "@chakra-ui/react";

import { useGetEditAppointment } from "modules/appointment/infrastructure/useGetEditAppointment";

import { useGetFriendlyUrl } from "utils/hooks/useGetFriendlyUrl";

import { ChakraText } from "components/ChakraText";
import { HeaderText } from "components/HeaderText";
import { WarningWidget } from "components/Widgets";
import PreventLossData from "components/PreventLossData";

import { TimeTable } from "../../Reservation/components/TimeTable";
import { EditAppointment } from "./EditAppointment";
import { TokenExpiredErrorBoundary } from "../Commons/TokenExpiredErrorBoundary";
import { ReservationDetails } from "../../Commons/ReservationDetails";

const EditPageThrowable = () => {
  const { tokenId } = useParams<{ tokenId: string }>();
  const { friendlyUrl } = useGetFriendlyUrl();

  const { data: appointment } = useGetEditAppointment(tokenId, {
    refetchOnWindowFocus: false,
  });

  if (!appointment) {
    return <></>;
  }

  return (
    <Box>
      <HeaderText>Zmiana terminu wizyty</HeaderText>
      <Flex mt={4} justifyContent="center">
        <ChakraText fontWeight="bold">Aktualny termin wizyty</ChakraText>
      </Flex>
      <ReservationDetails appointment={appointment} />

      <Flex mt={8} justifyContent="center">
        <ChakraText fontWeight="bold">Zmień termin wizyty</ChakraText>
      </Flex>
      {appointment.queueId ? (
        <TimeTable
          queueId={appointment.queueId}
          availableDate={appointment.startDate}
        >
          {({ selectedInterval }) => (
            <EditAppointment
              intervalElement={selectedInterval}
              tokenId={tokenId}
              appointment={appointment}
            />
          )}
        </TimeTable>
      ) : (
        <WarningWidget>
          <ChakraText fontSize={{ base: "xl", md: "2xl" }} alignSelf="center">
            Brak możliwości rejestracji terminu
          </ChakraText>
        </WarningWidget>
      )}
      <PreventLossData
        when={(nextLocation) =>
          nextLocation.pathname !== `/e-rezerwacja/${friendlyUrl}`
        }
        message="Uwaga opuszczasz tryb zmiany terminu nie dokonując rezerwacji nowego."
      />
    </Box>
  );
};

const EditPage = () => {
  return (
    <TokenExpiredErrorBoundary>
      <EditPageThrowable />
    </TokenExpiredErrorBoundary>
  );
};

export default EditPage;
